module.exports = __webpack_public_path__ + "e03364837d1d96c6459c58406ebd7308.pdf";